const IOS_CALENDAR_SETUP_KEY = "mem.ios.calendar.setup";

export const writeIosCalendarSetup = (state: boolean) => {
  window.sessionStorage.setItem(IOS_CALENDAR_SETUP_KEY, String(state));
};

export const readIosCalendarSetup = (): boolean => {
  const state = window.sessionStorage.getItem(IOS_CALENDAR_SETUP_KEY);
  return state === "true";
};

export const clearIosCalendarSetup = () => {
  window.sessionStorage.removeItem(IOS_CALENDAR_SETUP_KEY);
};
